import Vue from 'vue'
import axios from 'axios'

let uconfig = {
    withCredentials: false,
    headers: {
        "Content-Type": ""
    },
}
let uaxios = axios.create(uconfig);
Vue.prototype.$uaxios = uaxios
export default uaxios;
